import React, { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { menuSectionsTwo } from "./menuSectionsTwo";

const Protected = ({ children }) => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const adminInfo = localStorage.getItem('admin-info');
        if (!adminInfo) {
            navigate("/")
        } else {
            const { Web_MenuAccess } = JSON.parse(adminInfo);
            const userRoles = Web_MenuAccess.split(",").map(role => role.trim());
            
            // Check if the current path is allowed for the user's role
            const isPathAllowed = menuSectionsTwo.some(section => 
                section.items.some(item => 
                    item.path === location.pathname && userRoles.includes(item.role)
                )
            );

            if (!isPathAllowed && location.pathname !== "/dashboard/dashbordhome") {
                navigate("/dashboard/dashbordhome");
            }
        }
    }, [navigate, location]);

    return children;
};

export default Protected